import React, { ReactNode } from 'react';
import Typography from './typography';

import '@styles/button.scss';

interface ImageButtonProps {
  ButtonIcon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  variant: 'outlined' | 'text' | 'contained';
  onClick?: () => void;
  children?: ReactNode;
  ariaLabel: string;
}

export const ImageButton = ({
  ButtonIcon,
  variant = 'contained',
  size = 'medium',
  onClick,
  children,
  ariaLabel,
  ...props
}: ImageButtonProps) => {
  const sizeMapping = {
    xsmall: 'xs',
    small: 'sm',
    medium: 'md',
    large: 'lg',
    xlarge: 'x',
  };

  const style: any = size ? sizeMapping[size] : 'md';

  return (
    <button
      className={['image-button', `image-button--${size}`, variant].join(' ')}
      type="button"
      role="button"
      aria-label={ariaLabel}
      onClick={onClick}
      {...props}
    >
      <span className="image-button__icon">
        <ButtonIcon />
      </span>
      <Typography variant="button" size={style}>
        {children}
      </Typography>
    </button>
  );
};
